export default __webpack_public_path__ + "static/media/icon_Chalkboard_Teacher_.8b2f996e.svg";